<template>
  <tr class="grid_table" :class="isExtra ? '' : 'fw500'">
    <td>
      {{ position }}
    </td>
    <td>
      {{
        work['is_hourly'] === 1 || isExtra
          ? $formatTime(work['approved_report'])
          : $formatCurrency(work['approved_report']) + ' ' + work['measure']
      }}
    </td>
    <td>{{ work['name'] }}</td>
    <td>{{ $formatCurrency(work['price']) }}</td>
    <template v-if="edit">
      <td class="pa-0">
        <v-select
          dense
          hide-details
          validate-on-blur
          outlined
          class="f12 none_border"
          v-model="work['vat_code']"
          :items="listVatCode"
          item-value="code"
          item-text="percent"
          :placeholder="work['tax_percent'] ? String(work['tax_percent']) : '—'"
          :menu-props="{ bottom: true, offsetY: true }"
          @change="percentChange"
          :rules="[(v) => !!v || '']"
        >
          <template v-slot:append>
            <div class="f12 none_border fw500">%</div>
          </template>
          <template v-slot:item="scope">
            {{ scope.item.percent + '% ' + scope.item.description }}
          </template>
        </v-select>
      </td>
    </template>
    <td v-else>{{ String(work['tax_percent'] || 0) + ' %' }}</td>
    <td>{{ $formatCurrency(work['total_price']) }}</td>
    <td>{{ $formatCurrency(work['total_price_with_tax']) }}</td>
  </tr>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "FinanceInvoiceShowTableItem",
  props: {
    work: {
      type: Object,
      default: () => {
        return {}
      }
    },
    position: {
      type: [Number, String],
      default: 0
    },
    isExtra: Boolean,
    edit: Boolean,
    onPercentChange: {},
  },
  computed: {
    ...mapGetters('commonVatCode', {listVatCode: 'getCommonVatCodeGrid'}),
  },
  methods: {
    ...mapActions('workClientProjectsClientBills', ['onWorkClientProjectsClientBillUpdate']),
    percentChange(e) {
      if (this.onPercentChange) {
        this.onPercentChange(this.listVatCode.filter(i => i.code == e)[0].id, this.work.id)
      }
    },
  }
}
</script>
